var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2753 35.7735C44.2327 32.31 38.8994 33.7531 36.9136 34.9077C34.928 36.0622 32.6581 39.2369 33.5091 43.5663C34.3602 47.8956 42.871 50.4933 46.2753 46.1639C49.6795 41.8345 47.8073 38.3714 46.2753 35.7735Z",
    stroke: "#43D48A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9498 4.17146C12.9073 0.707956 7.57398 2.1511 5.58818 3.3056C3.60258 4.4601 1.33265 7.63482 2.1837 11.9642C3.03475 16.2936 11.5456 18.8912 14.9498 14.5618C18.354 10.2324 16.4819 6.76938 14.9498 4.17146Z",
    stroke: "#43D48A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4181 38.0546H41.4185C43.4195 37.7065 45.4205 42.8194 41.4185 43.7723C37.4165 44.7253 37.4869 41.6652 38.0835 39.9605C38.7504 38.0546 40.3065 38.0546 41.4181 38.0546Z",
    stroke: "#43D48A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3472 5.48047C34.6789 16.309 14.6461 39.8224 11.8616 47.2477",
    stroke: "#43D48A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountIcon);
export default __webpack_public_path__ + "static/media/discount_icon.29fa7c07e0cb67b39af4d2b24b6cc067.svg";
export { ForwardRef as ReactComponent };